import React, { useState, useEffect } from 'react';
import axios from 'axios'
import { useWhiteLabelServiceSettings } from 'cng-web-lib'
import TradeResourcesView from 'src/views/staticHomeView/ups/UPSHomeView/TradeResourcesView';

const components = {
    UpsTradeResources: TradeResourcesView
};

function TradeResources({ defaultPagePath }) {
    const whiteLabelServiceSettings = useWhiteLabelServiceSettings("custom-layout")
    const [htmlPageState, setHtmlPageState] = new useState("");
    const [customPageId, setCustomPageId] = new useState(null);

    useEffect(() => {
        const axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*"
            }
        };

        //no default path
        let tradeResourcesPath = (defaultPagePath == null || defaultPagePath == undefined) ? "" : defaultPagePath;

        if (whiteLabelServiceSettings.length > 0) {
            let wbTradeResources = whiteLabelServiceSettings[0].custom.tradeResources
            if (wbTradeResources) {
                setCustomPageId(wbTradeResources)
            }
        }

        axios.get(process.env.PUBLIC_URL + tradeResourcesPath, axiosConfig).then(response => {
            setHtmlPageState(response.data)
        });
    }, []);

    function renderTradeResources(customPageId) {
        const TradeResources = components[customPageId];
        return (<TradeResources />)
    }

    if (customPageId) {
        return (renderTradeResources(customPageId))
    }
    return (
        <div style={{ padding: '5px' }}
            dangerouslySetInnerHTML={{ __html: htmlPageState }}
        />
    )
}

export default TradeResources; 